import React from 'react'

import SortableTable from '../../../_library/SortableTable'
import EmptyBar from '../../../_library/EmptyBar'
import LoadingBar from '../../../_library/LoadingBar'

import { getTableColumns } from '../../../utils/sortableTableUtils'
import { DAY_DISPLAY_FORMAT } from '../../../constants/timeFormats'
import { currencyNormalizerCreator, createFixedFloatNormalizer } from '../../../../_common/core/validation'

const AllOrders = ({ event, paymentPlansData, isLoadingPaymentPlans, isEmptyData }) => {
  const tableColumns = getTableColumns([
    { label: 'Order Date', key: 'order_date', formatTo: DAY_DISPLAY_FORMAT },
    { label: 'No. of Tickets Sold', key: 'quantity' },
    { label: 'Running Total  (No. of Tickets Sold)', key: 'numSalesTotal', isSortable: false },
    {
      label: 'Completed Payments',
      key: 'income',
      disableNormalizerOnCopy: true,
      normalizer: value =>
        currencyNormalizerCreator(getActiveCurrencySymbol(event, event?.selectedCurrency))(
          createFixedFloatNormalizer(2)(parseFloat(value)),
        ),
    },
    {
      label: 'Expected Payments',
      key: 'expected_income',
      disableNormalizerOnCopy: true,
      normalizer: value =>
        currencyNormalizerCreator(getActiveCurrencySymbol(event, event?.selectedCurrency))(
          createFixedFloatNormalizer(2)(parseFloat(value)),
        ),
    },
  ])
  const footbarColumns = [
    'quantity',
    {
      key: 'income',
      normalizer: value =>
        currencyNormalizerCreator(getActiveCurrencySymbol(event, event?.selectedCurrency))(
          createFixedFloatNormalizer(2)(parseFloat(value)),
        ),
    },
    {
      key: 'expected_income',
      normalizer: value =>
        currencyNormalizerCreator(getActiveCurrencySymbol(event, event?.selectedCurrency))(
          createFixedFloatNormalizer(2)(parseFloat(value)),
        ),
    },
  ]

  if (isLoadingPaymentPlans) {
    return <LoadingBar />
  }
  if (isEmptyData) {
    return <EmptyBar />
  }

  return (
    <div className="table-background">
      <SortableTable
        tableColumns={tableColumns}
        data={paymentPlansData || []}
        enableCopyTable={true}
        enableSort={true}
        disableMobileView={true}
        calculatedColumns={[{ for: 'numSalesTotal', column: 'quantity' }]}
        footbar={{
          label: 'Total',
          columns: footbarColumns,
        }}
        scrollToRowEnabled={true}
      />
    </div>
  )
}

export default AllOrders
